export default __webpack_public_path__ + "static/media/Holmes.2e218e4b.png";